// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"4121":"vendor","8792":"main"}[chunkId] + "." + __webpack_require__.h() + ".css";
};